"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = require("prop-types");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _dateFns = require("date-fns");

var _checkmark = _interopRequireDefault(require("../../assets/checkmark"));

var _errormark = _interopRequireDefault(require("../../assets/errormark"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var DateInputV4 = function DateInputV4(_ref) {
  var className = _ref.className,
      name = _ref.name,
      disabled = _ref.disabled,
      error = _ref.error,
      passedValue = _ref.value,
      initialValue = _ref.initialValue,
      onChange = _ref.onChange,
      onBlur = _ref.onBlur,
      onFieldChange = _ref.onFieldChange,
      onFieldBlur = _ref.onFieldBlur,
      children = _ref.children,
      iso = _ref.iso,
      allowIncomplete = _ref.allowIncomplete,
      dataTestId = _ref.dataTestId,
      touched = _ref.touched,
      withIcon = _ref.withIcon,
      rest = _objectWithoutProperties(_ref, ["className", "name", "disabled", "error", "value", "initialValue", "onChange", "onBlur", "onFieldChange", "onFieldBlur", "children", "iso", "allowIncomplete", "dataTestId", "touched", "withIcon"]);

  var _useState = (0, _react.useState)(initialValue || passedValue),
      _useState2 = _slicedToArray(_useState, 2),
      value = _useState2[0],
      setValue = _useState2[1];

  var _useState3 = (0, _react.useState)('iso'),
      _useState4 = _slicedToArray(_useState3, 2),
      returnType = _useState4[0],
      setReturnType = _useState4[1];

  var _useState5 = (0, _react.useState)(),
      _useState6 = _slicedToArray(_useState5, 2),
      lastPressedKey = _useState6[0],
      setLastPressedKey = _useState6[1];

  var dayRef = (0, _react.useRef)();
  var monthRef = (0, _react.useRef)();
  var yearRef = (0, _react.useRef)();
  var BACKSPACE = 8;
  var KEY_E = 69;
  var PERIOD = 190;
  var ARROW_LEFT = 37;
  var ARROW_UP = 38;
  var ARROW_RIGHT = 39;
  var ARROW_DOWN = 40;
  /** Converts the value to a date object */

  var getDateObjFromValue = function getDateObjFromValue(value) {
    var dateObj = {
      day: '',
      month: '',
      year: ''
    };

    if (value) {
      var valueDateObject = init(value) || {};
      Object.keys(valueDateObject).forEach(function (name) {
        dateObj = _extends({}, dateObj, _defineProperty({}, name, valueDateObject[name]));
      });
    }

    return dateObj;
  };

  var pad = function pad(n) {
    if (!parseInt(n)) return '';
    return parseInt(n) < 10 ? "0".concat(parseInt(n)) : n;
  };

  var isISODate = function isISODate(date) {
    return /[+-]?\d{4}(-[01]\d(-[0-3]\d(T[1-2]\d:[0-5]\d:?([0-5]\d(\.\d+)?)?[+-][0-2]\d:[0-5]\dZ?)?)?)/.test(date);
  };
  /**
   * Initializes a date object for multiple input types with error handling
   * @param {*} value The date value in string, object or ISO format
   */


  var init = function init(value) {
    if (value instanceof Date) {
      setReturnType(iso ? 'iso' : 'date');
      return {
        day: pad(value.getDate()),
        month: pad(value.getMonth()),
        year: value.getFullYear()
      };
    } else if (_typeof(value) === 'object') {
      setReturnType(iso ? 'iso' : 'object');
      return {
        day: pad(value.day),
        month: pad(value.month),
        year: value.year
      };
    } else if (isISODate(value)) {
      setReturnType('iso');
      var isoDate = new Date(value);
      return {
        day: pad(isoDate.getDate()),
        // Month +1 to adjust for javascript date starting from 00
        month: pad(isoDate.getMonth() + 1),
        year: isoDate.getFullYear()
      };
    } else if (typeof value === 'string') {
      if (value.includes('-') && value.includes('/')) {
        throw new Error('No valid seperators, use / or -');
      }

      if (iso) {
        setReturnType('iso');
      } else {
        setReturnType(value.includes('/') ? 'slash' : 'dash');
      }

      var values = value.split(value.includes('/') ? '/' : '-');
      return {
        day: pad(values[0] || ''),
        month: pad(values[1] || ''),
        year: values[2] || ''
      };
    }
  };

  var _useState7 = (0, _react.useState)({
    day: '',
    month: '',
    year: ''
  }),
      _useState8 = _slicedToArray(_useState7, 2),
      date = _useState8[0],
      setDate = _useState8[1];

  (0, _react.useEffect)(function () {
    var dateObj = getDateObjFromValue(value);
    setDate(dateObj);
  }, [value]);
  (0, _react.useEffect)(function () {
    if (!initialValue) setValue(passedValue);
  }, [passedValue]);
  (0, _react.useEffect)(function () {
    if (iso) {
      setReturnType('iso');
    } else {
      init(value);
    }
  }, [iso]);

  var onKeyDown = function onKeyDown(e) {
    setLastPressedKey(e.keyCode);

    if (e.keyCode === KEY_E || e.keyCode === PERIOD) {
      e.preventDefault();
    } else if (![BACKSPACE, ARROW_UP, ARROW_DOWN, ARROW_LEFT, ARROW_RIGHT].includes(e.keyCode)) return true;

    if (e.keyCode === BACKSPACE) {
      var _e$target$value;

      if (((_e$target$value = e.target.value) === null || _e$target$value === void 0 ? void 0 : _e$target$value.length) === 0) {
        e.preventDefault();
        handlePreviousField(e.target.name, true);
      }
    } else {
      e.preventDefault();
    }

    switch (e.keyCode) {
      case ARROW_UP:
        if (!isFalseNumber(e.target.name, Number(e.target.value) + 1)) {
          e.target.value = pad(Number(e.target.value) + 1);
          return handleFieldChange(e, false);
        }

        break;

      case ARROW_DOWN:
        if (!isFalseNumber(e.target.name, Number(e.target.value) - 1)) {
          e.target.value = pad(Number(e.target.value) - 1);
          return handleFieldChange(e, false);
        }

        break;

      case ARROW_LEFT:
        return handlePreviousField(e.target.name);

      case ARROW_RIGHT:
        return handleNextField(e.target.name);
    }
  };

  var getReturnDate = function getReturnDate(_date, _returnType) {
    if (!date) throw new Error('No date object provided');

    switch (_returnType) {
      case 'date':
        return new Date(_date.year, _date.month, _date.day);

      case 'object':
        return _date;

      case 'slash':
        return "".concat(_date.day, "/").concat(_date.month, "/").concat(_date.year);

      case 'dash':
        return "".concat(_date.day, "-").concat(_date.month, "-").concat(_date.year);

      case 'iso':
        // -1 to correct for javascript month starting from 00
        return (0, _dateFns.formatISO)(new Date(_date.year, _date.month - 1, _date.day));

      default:
        throw new Error('Return type not found');
    }
  };

  var allDatePropsDefined = function allDatePropsDefined(_date) {
    var _String;

    return Boolean((_date === null || _date === void 0 ? void 0 : _date.day) && (_date === null || _date === void 0 ? void 0 : _date.month) && ((_String = String(_date === null || _date === void 0 ? void 0 : _date.year)) === null || _String === void 0 ? void 0 : _String.length) > 3);
  };

  var isDateEmpty = function isDateEmpty(_date) {
    return !((_date === null || _date === void 0 ? void 0 : _date.day) || (_date === null || _date === void 0 ? void 0 : _date.month) || (_date === null || _date === void 0 ? void 0 : _date.year));
  };
  /** Callback with complete value */


  var handleChange = function handleChange(_date, _returnType) {
    var returnValue = getReturnDate(_date, _returnType);
    if (allowIncomplete || allDatePropsDefined(_date)) onChange({
      name: name,
      value: returnValue,
      dateObj: _date,
      isValid: allDatePropsDefined(_date),
      isEmpty: isDateEmpty(_date)
    });else onChange({
      name: name,
      value: undefined,
      dateObj: _date,
      isValid: allDatePropsDefined(_date),
      isEmpty: isDateEmpty(_date)
    });
  };
  /** Callback with complete value */


  var handleBlur = function handleBlur(_date, _returnType) {
    var returnValue = getReturnDate(_date, _returnType);
    if (allowIncomplete || allDatePropsDefined(_date)) onBlur({
      name: name,
      value: returnValue,
      dateObj: _date,
      isValid: allDatePropsDefined(_date),
      isEmpty: isDateEmpty(_date)
    });else onBlur({
      name: name,
      value: undefined,
      dateObj: _date,
      isValid: allDatePropsDefined(_date),
      isEmpty: isDateEmpty(_date)
    });
  };

  var handlePreviousField = function handlePreviousField(name, noSelect) {
    if (name === 'month') {
      dayRef.current.focus();
      !noSelect && dayRef.current.select();
      return true;
    } else if (name === 'year') {
      monthRef.current.focus();
      !noSelect && monthRef.current.select();
      return true;
    }

    return false;
  };

  var handleNextField = function handleNextField(name) {
    if (name === 'day') {
      monthRef.current.focus();
      monthRef.current.select();
      return true;
    } else if (name === 'month') {
      yearRef.current.focus();
      yearRef.current.select();
      return true;
    }

    return false;
  };

  var isFalseNumber = function isFalseNumber(name, value) {
    if (name === 'day') {
      return value > 31 || value < 0;
    } else if (name === 'month') {
      return value > 12 || value < 0;
    } else {
      return false;
    }
  };
  /** Callback with single value */


  var handleFieldChange = function handleFieldChange(_ref2, move) {
    var _value, _value6;

    var _ref2$target = _ref2.target,
        name = _ref2$target.name,
        value = _ref2$target.value;
    if (name === 'year' ? ((_value = value) === null || _value === void 0 ? void 0 : _value.length) > 4 : value.length > 2) return;
    var moved = false;

    if (name === 'day') {
      var _value2, _value3;

      if (isFalseNumber(name, value)) {
        return;
      } else if ((((_value2 = value) === null || _value2 === void 0 ? void 0 : _value2.length) === 2 || value > 3 && lastPressedKey !== BACKSPACE) && move) {
        moved = handleNextField(name);
      } else if (((_value3 = value) === null || _value3 === void 0 ? void 0 : _value3.length) > 2) {
        value = value.substring(0, 2);
      }
    } else if (name === 'month') {
      var _value4, _value5;

      if (isFalseNumber(name, value)) {
        return;
      } else if ((((_value4 = value) === null || _value4 === void 0 ? void 0 : _value4.length) === 2 || value > 1 && lastPressedKey !== BACKSPACE) && move) {
        moved = handleNextField(name);
      } else if (((_value5 = value) === null || _value5 === void 0 ? void 0 : _value5.length) > 2) {
        value = value.substring(0, 2);
      }
    } else if (name === 'year' && ((_value6 = value) === null || _value6 === void 0 ? void 0 : _value6.length) > 4) {
      return;
    }

    var changedDate = _extends({}, date, _defineProperty({}, name, moved ? pad(value || '') : value));

    setDate(changedDate);
    onFieldChange({
      name: name,
      value: value
    });
    handleChange(changedDate, returnType);
  };

  var handleFieldBlur = function handleFieldBlur(_ref3) {
    var _ref3$target = _ref3.target,
        name = _ref3$target.name,
        value = _ref3$target.value;
    var changedDate;
    if (name !== 'year') changedDate = _extends({}, date, _defineProperty({}, name, pad(value || '')));else changedDate = _extends({}, date, _defineProperty({}, name, value || ''));
    setDate(changedDate);
    onFieldBlur({
      name: name,
      value: value
    });
    handleBlur(changedDate, returnType);
  };

  var handleOnPaste = function handleOnPaste(e, maxLength) {
    var pastedText = (e.clipboardData || window.clipboardData).getData('text'); // Avoids the ability to paste text with alphabetic characeters and/or longer than the given max length

    if (!new RegExp("^\\d{1,".concat(maxLength, "}$")).test(pastedText)) e.preventDefault();
  };

  return /*#__PURE__*/_react.default.createElement(Container, _extends({
    className: className,
    name: name,
    hasChildren: !!children
  }, rest), /*#__PURE__*/_react.default.createElement(StyledLabel, {
    disabled: disabled
  }, children, /*#__PURE__*/_react.default.createElement(Input, {
    disabled: disabled,
    error: error,
    touched: touched,
    hasChildren: !!children,
    withIcon: withIcon,
    dataTestId: dataTestId
  }, /*#__PURE__*/_react.default.createElement(DateInput, {
    name: "day",
    placeholder: "DD",
    maxLength: 2,
    ref: dayRef,
    onChange: function onChange(val) {
      return handleFieldChange(val, true);
    },
    onBlur: handleFieldBlur,
    value: date.day,
    disabled: disabled,
    onKeyDown: onKeyDown,
    type: "number",
    "data-test-id": "".concat(dataTestId, "_day"),
    onPaste: function onPaste(e) {
      return handleOnPaste(e, 2);
    }
  }), /*#__PURE__*/_react.default.createElement(Slash, null, "/"), /*#__PURE__*/_react.default.createElement(DateInput, {
    name: "month",
    placeholder: "MM",
    maxLength: 2,
    ref: monthRef,
    onChange: function onChange(val) {
      return handleFieldChange(val, true);
    },
    onBlur: handleFieldBlur,
    value: date.month,
    disabled: disabled,
    onKeyDown: onKeyDown,
    type: "number",
    "data-test-id": "".concat(dataTestId, "_month"),
    onPaste: function onPaste(e) {
      return handleOnPaste(e, 2);
    }
  }), /*#__PURE__*/_react.default.createElement(Slash, null, "/"), /*#__PURE__*/_react.default.createElement(DateInput, {
    name: "year",
    placeholder: "YYYY",
    maxLength: 4,
    ref: yearRef,
    onChange: handleFieldChange,
    onBlur: handleFieldBlur,
    value: date.year,
    disabled: disabled,
    onKeyDown: onKeyDown,
    type: "number",
    year: true,
    "data-test-id": "".concat(dataTestId, "_year"),
    onPaste: function onPaste(e) {
      return handleOnPaste(e, 4);
    }
  }), withIcon && error && touched ? /*#__PURE__*/_react.default.createElement(StyledErrormark, {
    color: "#F74040"
  }) : withIcon && touched && /*#__PURE__*/_react.default.createElement(StyledCheckmark, {
    color: "#49C562"
  }))), error ? /*#__PURE__*/_react.default.createElement(ErrorContainer, {
    className: "errorBox"
  }, /*#__PURE__*/_react.default.createElement(ErrorMss, {
    name: name,
    component: "p",
    className: "error"
  }, error)) : null);
};

var StyledErrormark = (0, _styledComponents.default)(_errormark.default).withConfig({
  displayName: "StyledErrormark"
})(["position:absolute;right:1rem;align-self:center;transition:0.2s;"]);
var StyledCheckmark = (0, _styledComponents.default)(_checkmark.default).withConfig({
  displayName: "StyledCheckmark"
})(["position:absolute;right:1rem;align-self:center;transition:0.2s;"]);

var ErrorContainer = _styledComponents.default.div.withConfig({
  displayName: "ErrorContainer"
})(["height:1.5rem;margin-top:0.8rem;display:flex;width:100%;align-items:center;justify-content:flex-end;text-align:right;margin-right:0.5rem;color:", ";"], function (_ref4) {
  var theme = _ref4.theme;
  return theme.brand.primary;
});

var ErrorMss = _styledComponents.default.p.withConfig({
  displayName: "ErrorMss"
})(["color:red;font-size:1.1rem;width:100%;margin-top:-1rem;margin-left:0.5rem;text-align:right;"]);

var Input = _styledComponents.default.div.withConfig({
  displayName: "Input"
})(["position:relative;display:flex;align-items:center;grid-template-columns:repeat(3,1fr);font-size:1.7rem;width:100%;background-color:", ";padding-left:1.2rem;margin-top:", ";border:1px solid;height:4rem;border-color:", ";border-radius:3px;"], function (_ref5) {
  var disabled = _ref5.disabled;
  return disabled ? '#F0F1F3' : 'white';
}, function (_ref6) {
  var hasChildren = _ref6.hasChildren;
  return hasChildren ? '0.8rem' : 0;
}, function (_ref7) {
  var error = _ref7.error,
      touched = _ref7.touched,
      theme = _ref7.theme,
      withIcon = _ref7.withIcon;
  return error ? theme.status.error : touched && withIcon && !error ? theme.status.succes : '#e4e4e4';
});

var Slash = _styledComponents.default.span.withConfig({
  displayName: "Slash"
})(["color:#757575;margin:2px 1px 1px 1px;font-size:1.8rem;"]);

var DateInput = _styledComponents.default.input.withConfig({
  displayName: "DateInput"
})(["background-color:transparent;outline:none;border:none;width:", ";font-size:1.5rem;text-align:center;&::-webkit-outer-spin-button,&::-webkit-inner-spin-button{-webkit-appearance:none;margin:0;}&[type='number']{-moz-appearance:textfield;}"], function (_ref8) {
  var year = _ref8.year;
  return year ? '5rem' : '3.3rem';
});

var StyledLabel = _styledComponents.default.label.withConfig({
  displayName: "StyledLabel"
})(["display:flex;flex-direction:column;position:relative;width:100%;font-size:1.4rem;color:", ";line-height:120%;"], function (_ref9) {
  var disabled = _ref9.disabled,
      theme = _ref9.theme;
  return disabled ? theme.ui.disabled : theme.labels.guaranteeText;
});

var Container = _styledComponents.default.div.withConfig({
  displayName: "Container"
})(["font-family:", ";width:100%;height:", ";"], function (_ref10) {
  var theme = _ref10.theme;
  return theme.font;
}, function (_ref11) {
  var hasChildren = _ref11.hasChildren;
  return hasChildren ? '9rem' : 'auto';
});

DateInputV4.defaultProps = {
  disabled: false,
  onBlur: function onBlur() {},
  onChange: function onChange() {},
  onFieldChange: function onFieldChange() {},
  onFieldBlur: function onFieldBlur() {}
};
DateInputV4.propTypes = {
  /** Beeing able to use it in Styled Components */
  className: _propTypes.string,

  /** Name of input and label */
  name: _propTypes.string,

  /** Label above the input */
  children: _propTypes.node,

  /** Is the input field disabled */
  disabled: _propTypes.bool,

  /** Error for the input */
  error: _propTypes.string,

  /** Callback function that is fired when focusing any input field. */
  onChange: _propTypes.func,

  /** Callback function that is fired when changing any input field. */
  onBlur: _propTypes.func,

  /** Callback function that is fired when focusing a single input field. */
  onFieldChange: _propTypes.func,

  /** Callback function that is fired when changing a single input field. */
  onFieldBlur: _propTypes.func,

  /** Current value of the input element */
  value: (0, _propTypes.oneOfType)([_propTypes.object, _propTypes.string]),

  /** The initial value of the date, use onChange to get updated values */
  initialValue: (0, _propTypes.oneOfType)([_propTypes.object, _propTypes.string]),

  /** Force return as ISO */
  iso: _propTypes.bool,

  /** Allow incomplete dates to be returned to the onChange and onBlur */
  allowIncomplete: _propTypes.bool,

  /** Adds extra props to the element */
  rest: _propTypes.object,

  /** Test id for data */
  dataTestId: _propTypes.string,

  /** Has field been touched */
  touched: _propTypes.bool,

  /** Should field include icons */
  withIcon: _propTypes.bool
};
var _default = DateInputV4;
exports.default = _default;